/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Link } from 'react-router';
import AdminTabs from '../../util/tabs/AdminTabs';
import AdminUserForm from '../../../forms/AdminUserForm';
import { simpleNotification } from '../../../../utils/notifications';
import './UserEdit.scss';
import Axios from 'axios';

class UserEdit extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {

    };
    this.userLoaded = false;
    this.oldFreezeBool = false;
    this.oldYoutubeFreezeBool = false;
  }

  UNSAFE_componentWillMount() {
    const { token } = this.props.auth;
    const { userId } = this.props.router.params;
    this.props.getAUser(userId, token);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.admin.user.isLoading === true && !this.userLoaded) {
      const { data: user } = this.props.admin.user;
      // check to update date/time and user for manual freeze
      if (user.freezeTwitchViewers) {
        this.oldFreezeBool = user.freezeTwitchViewers.isFrozen;
      }
      if (user.freezeYoutubeViews) {
        this.oldYoutubeFreezeBool = user.freezeYoutubeViews.isFrozen;
      }


      let editUser = {};
      // if (user.connectedAccounts && user.connectedAccounts.huya.profileRoom) {
      //   editUser = {
      //     ...user,
      //     profileRoom: user.connectedAccounts.huya.profileRoom,
      //     huyaUsername: user.connectedAccounts.huya.username,
      //     huya: 'True',
      //   };
      // } else {
      editUser = { ...user };
      // }
      this.userLoaded = true;
      this.props.assignEditUserInfo(editUser);
    } else if (prevProps.admin.user.isLoading === true && this.userLoaded) {
      const userErrors = this.props.admin.user.errors;
      if (userErrors && userErrors.hasError) {
        // Previously this branch always reported success — a failed update showed "User Updated"
        // and redirected. Surface the real error instead.
        simpleNotification({
          level: 'error',
          title: 'User Not Updated.',
          message: userErrors.message || 'Something went wrong while updating the user. Please try again.',
        });
      } else {
        simpleNotification({
          level: 'success',
          title: 'User Updated.',
          message: 'The user has been updated successfully.',
        });
        this.props.router.replace('/admin/users');
      }
    }
  }

  onSubmit = (data, disconnectedPlatforms) => {
    const { userId } = this.props.router.params;
    const { token } = this.props.auth;

    let freezeObject = { isFrozen: false };
    if (data.freezeTwitchViewers) {
      freezeObject = { ...data.freezeTwitchViewers };
      if (this.oldFreezeBool !== data.freezeTwitchViewers.isFrozen) {
        freezeObject = { isFrozen: data.freezeTwitchViewers.isFrozen, dateFrozen: new Date(), whoFroze: this.props.auth.user.username };
      }
    }

    let youtubeFreezeObject = { isFrozen: false };
    if (data.freezeYoutubeViews) {
      youtubeFreezeObject = { ...data.freezeYoutubeViews };
      if (this.oldYoutubeFreezeBool !== data.freezeYoutubeViews.isFrozen) {
        youtubeFreezeObject = { isFrozen: data.freezeYoutubeViews.isFrozen, dateFrozen: new Date(), whoFroze: this.props.auth.user.username };
      }
    }

    let submitData = {
      ...data,
      freezeTwitchViewers: freezeObject,
      freezeYoutubeViews: youtubeFreezeObject,
    };

    // Ensure connectedAccounts exists
    if (!submitData.connectedAccounts) {
      submitData.connectedAccounts = {};
    }

    // Handle platform disconnects by setting id and username to null
    const platforms = ['twitch', 'twitter', 'steam', 'youtube'];
    platforms.forEach(platform => {
      if (disconnectedPlatforms.has(platform)) {
        submitData.connectedAccounts[platform] = {
          id: null,
          username: null,
        };
      }
    });

    // Handle Twitch AVG Viewers if Twitch is still connected
    if (!disconnectedPlatforms.has('twitch') && submitData.connectedAccounts?.twitch?.AVGViewers) {
      submitData.connectedAccounts.twitch = {
        ...submitData.connectedAccounts.twitch,
        AVGViewers: parseInt(submitData.connectedAccounts.twitch.AVGViewers, 10),
      };
    }

    this.props.updateAUser(userId, submitData, token);
  }

  // 添加到 UserEdit 类中的方法
  cancelTwitchAuthorization = async () => {
    const { userId } = this.props.router.params;
    const { token } = this.props.auth;

    // 确认对话框
    if (window.confirm("Are you sure you want to cancel this user's Twitch authorization?")) {
      // 可以添加一个加载状态
      this.setState({ isCancelling: true });

      try {
        // 直接使用 Axios 发送 POST 请求
        const config = {
          headers: {
            Authorization: `JWT ${token}`,
            'Content-Type': 'application/json'
          }
        };

        // 调用 API
        await Axios.get(
          `/api/v1/twitch/destroyUserTwitch`, {
          params: {
            userid: userId
          }
        }, // 空请求体
          config
        );

        // 显示成功通知
        simpleNotification({
          level: 'success',
          title: 'Twitch Authorization Canceled',
          message: 'The user\'s Twitch authorization has been successfully canceled.',
        });

        // 重新加载用户数据
        this.userLoaded = false;
        this.props.getAUser(userId, token);

      } catch (error) {
        // 显示错误通知
        simpleNotification({
          level: 'error',
          title: 'Error',
          message: error.response?.data?.message || error.message || 'Failed to cancel Twitch authorization',
        });
        console.error('Error canceling Twitch authorization:', error);
      } finally {
        // 无论成功或失败，都关闭加载状态
        this.setState({ isCancelling: false });
      }
    }
  }

  render() {
    const { userId } = this.props.router.params;
    const { data: user } = this.props.admin.user;

    return (
      <section className="AUserEdit">
        <section className="AUserEdit__wrapper">
          <AdminTabs {...this.props} />
          <section className="AUserEdit__content">
            <h2 className="AUserEdit__title">EDIT USER</h2>
            <div className="AUserEdit__actions">
              <Link
                to="/admin/users"
                activeClassName="active"
                href="/admin/users"
              >
                <button>Back</button>
              </Link>

              {
                user?.connectedAccounts?.twitch?.id && (
                  <button
                    onClick={this.cancelTwitchAuthorization}
                  >
                    Cancel Twitch Authorization
                  </button>
                )
              }

            </div>
            <AdminUserForm
              onSubmit={this.onSubmit.bind(this)}
              adminUserForm={this.props.form.adminUserForm}
              auth={this.props.auth}
              currUserId={userId}
              onDeleteSuccess={() => this.props.router.replace('/admin/users')}
            />
          </section>
        </section>
      </section>
    );
  }
}

export default UserEdit;
